module.exports = __webpack_public_path__ + "static/media/9. Nódulos, Mixta en tela, 80 x 180 cm, 2018 copy.2b7e60bf.png";